// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import {
    getTECertificateState,
    TECertificateStateContext,
} from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesSelectors";
import displayCertificate from "@store/Framework/Store/Greif/Pages/TECNotification/Handlers/DisplayCertificate";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);

    let certificateId;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ certificateId: string }>(location.search);
        certificateId = parsedQuery.certificateId;
    }

    const isCertificateIdStoredInState = state.greif.pages.tecContactSupport.certificateId === certificateId;

    return {
        certificateId,
        certificateState: getTECertificateState(state, certificateId),
        shouldDisplayCertificate: !isCertificateIdStoredInState,
        shouldLoadCountries: !countriesDataView.value && !countriesDataView.isLoading,
    };
};

const mapDispatchToProps = {
    displayCertificate,
    loadCurrentCountries,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface TECContactSupportStyles {
    page?: MobiusPageProps;
}

const tecContactSupportStyles: TECContactSupportStyles = {};

const styles = tecContactSupportStyles;

const TaxExemptionCertificatesPage = ({
    id,
    certificateId,
    shouldDisplayCertificate,
    certificateState,
    shouldLoadCountries,
    displayCertificate,
    loadCurrentCountries,
}: Props) => {
    useEffect(() => {
        if (certificateId && shouldDisplayCertificate) {
            displayCertificate({ certificateId });
        }
    });

    useEffect(() => {
        if (shouldLoadCountries) {
            loadCurrentCountries();
        }
    }, []);

    return (
        <Page data-test-selector="tecContactSupport" {...styles.page}>
            <TECertificateStateContext.Provider value={certificateState}>
                <Zone contentId={id} zoneName="Content" />
            </TECertificateStateContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TaxExemptionCertificatesPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;
